var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90909 0H1.27273C0.572727 0 0 0.572727 0 1.27273V10.1818H1.27273V1.27273H8.90909V0ZM10.8182 2.54545H3.81818C3.11818 2.54545 2.54545 3.11818 2.54545 3.81818V12.7273C2.54545 13.4273 3.11818 14 3.81818 14H10.8182C11.5182 14 12.0909 13.4273 12.0909 12.7273V3.81818C12.0909 3.11818 11.5182 2.54545 10.8182 2.54545ZM10.8182 12.7273H3.81818V3.81818H10.8182V12.7273Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyButton);
export default __webpack_public_path__ + "static/media/copy-button.7a5757f809741e460e1e90136ed1baf5.svg";
export { ForwardRef as ReactComponent };